import { useAtom, WritableAtom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { useMemo } from 'react';

export const useCustomFieldFilter = (
  id: number,
  customFieldsFilterAtom: WritableAtom<any, [any], void>,
) => {
  const customFieldFilterAtom = useMemo(
    () => focusAtom(customFieldsFilterAtom, (optic) => optic.prop(id)),
    [id],
  );

  return useAtom(customFieldFilterAtom);
};
